import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { fireUIInteractionEvent } from '../analytics/v3'
import { selectStateForProtobuf } from '../reducers'
import { selectIfChatbotLoading } from '../reducers/chatbot'
import { startSierra } from '../reducers/chatbot/actions'

export const useChatbot = () => {
  const dispatch = useDispatch()
  const isChatbotLoading = useSelector(selectIfChatbotLoading)
  const isChatbotEnabled = true
  const stateForProtobuf = useSelector(selectStateForProtobuf)

  const handleStartChat = useCallback(
    (e) => {
      e.preventDefault()
      dispatch(startSierra())
      fireUIInteractionEvent(
        {
          component: 'chatbot',
          element: 'opened',
          type: 'clicked',
        },
        stateForProtobuf
      )
    },
    [dispatch]
  )

  return {
    isChatbotLoading,
    isChatbotEnabled,
    handleStartChat,
  }
}
